import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { CustomAction } from '@nimmsta/ng-commons-lib/data-table';
import {
  Organization,
  OrganizationStatus,
} from '@nimmsta/ng-commons-lib/models';

_('organizations.approve');
_('organizations.decline');

export class ApproveDeclineAction extends CustomAction<Organization> {
  override getText(item: Organization): string {
    switch (item.status) {
      case OrganizationStatus.INACTIVE:
        return 'organizations.approve';
      default:
        return 'organizations.decline';
    }
  }
}
